import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import http from "@shared/api/http";
import "@/assets/styles/Utils.css";
import { useTranslation } from "react-i18next";

function sendTherapistRegistration(mail, password, tnc, props) {
  const url = "/de/react/0000/account.json";
  var params = new FormData();
  params.append("account[email]", mail.toLowerCase());
  params.append("account[password]", password);
  params.append("account[tnc]", tnc === true ? 1 : 0);
  http
    .post(url, params)
    .then(function () {
      props.setRegistrationSuccess(true);
    })
    .catch(function () {
      props.setRegistrationFailed(true);
    });
}

export function NewTherapistRegistration(props) {
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [pwRepeat, setPwRepeat] = useState("");
  const [tnc, setTnc] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (password === pwRepeat) {
      sendTherapistRegistration(mail, password, tnc, props);
      props.onHide();
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("user.therapist-registration-title", {
              defaultValue: "Neues Therapeuten-Konto",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="therapistRegEmail">
            <Form.Label>{t("password.mail")}</Form.Label>
            <Form.Control
              type="email"
              placeholder="user@sophyapp.com"
              autoFocus
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              required
              onChange={(e) => setMail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="therapistRegPw">
            <Form.Label>{t("password.at-least-characters")}</Form.Label>
            <Form.Control
              type="password"
              pattern=".{8,20}"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="therapistRegPwRepeat">
            <Form.Label>{t("password.repeat")}</Form.Label>
            <Form.Control
              type="password"
              pattern=".{8,20}"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              onChange={(e) => setPwRepeat(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="therapistRegTnc">
            <Form.Check
              type="checkbox"
              label={
                <span>
                  Ich akzeptiere die{" "}
                  <a
                    href="https://www.hoferdigital.at/impressum-datenschutz/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Geschäftsbedingungen
                  </a>{" "}
                  und{" "}
                  <a
                    href="https://app.sophyapp.com/users/generate_pdf/Ihr%20Unternehmen.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Datenschutzbestimmungen
                  </a>
                </span>
              }
              checked={tnc}
              onChange={(e) => setTnc(e.target.checked)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit" disabled={!tnc}>
            {t("actions.send")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
